import { client, errorValidation } from "./service";

export const getJastipList = async function ({
    orderCode, status,
    dateType,
    startDate,
    endDate,
    event,
    customer,
    page,
    limit
}) {
    try {
        let response = await client.get(`/jastip/list`, {
            params: {
                dateType,
                startDate: startDate || '',
                endDate: endDate || '',
                orderCode,
                status: Array.isArray(status) ? status.join(',') : status,
                event,
                customer,
                page,
                limit
            }
        })
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return errorValidation(e)
    }
}

export const getJastip = async function ({
    id
}) {
    try {
        let response = await client.get(`/jastip/detail/${id}`)
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        return errorValidation(e)
    }
}

export const addJastip = async function ({
    custName, custPhoneNumber, events, images, addressDetail, shoppingRequest, additionalFee,
    isReseller, downPayment, qty, qtyType, price, totalPrice, dp, discount
}) {
    try {
        let response = await client.post(`/jastip/create`, {
            custName, custPhoneNumber, eventId: events, images, addressDetail, isReseller, downPayment, shoppingRequest, additionalFee,
            qty, qtyType, price, totalPrice, dp, discount
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        // return { error: e.response.data.errorCode }
        return errorValidation(e)
    }
}

export const updateJastip = async function ({
    id,
    custName, custPhoneNumber, events, images, addressDetail, shoppingRequest,additionalFee,
    isReseller, downPayment, 
    qty,
    qtyType, 
    price, 
    totalPrice,
    paymentDp, payment, deliver, complete, failed, dp, discount, dpPaid
}) {
    try {
        let response = await client.post(`/jastip/update/${id}`, {
            custName, custPhoneNumber, events, images, addressDetail, 
            shoppingRequest : shoppingRequest || [], 
            additionalFee : additionalFee || [],
            isReseller, downPayment, 
            qty,
            qtyType, 
            price, 
            totalPrice,
            paymentDp, payment, deliver, complete, failed, dp, discount, dpPaid
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        // return { error: e.response.data.errorCode }
        return errorValidation(e)
    }
}

export const updateJastipImage = async function ({
    id, images
}) {
    try {
        let response = await client.post(`/jastip/update-image/${id}`, {
            images
        });
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        // return { error: e.response.data.errorCode }
        return errorValidation(e)
    }
}

export const deleteJastip = async function ({
    _id
}) {
    try {
        let response = await client.get(`/me/${_id}`);
        if (response.data.statusCode !== 200) { throw response.data.data; }
        let data = response.data.data;
        return { data };
    } catch (e) {
        // return { error: e.response.data.errorCode }
        return errorValidation(e)
    }
}